import { Component, Renderer2 } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { CurrencySettingsService } from '../../../core/services/currency-setting.service';
import { CommonModule } from '@angular/common';
import { LangPipe } from '../../pipes/lang.pipe';
import { IndexedDbService } from '../../../core/services/indexed-dbservice.service';
import { AuthService } from '../../../core/services/auth-service.service';
import { ApiService } from '../../../core/services/api.service';
import { AppConstants_settings } from '../../../core/AppConstants_Appsettings.enum';
import { ConvertArrayPipe } from '../../pipes/convertArray.pipe';

@Component({
  selector: 'app-dashboard-header',
  standalone: true,
  imports: [RouterOutlet, CommonModule, RouterLink, LangPipe],
  templateUrl: './dashboard-header.component.html',
  providers: [ConvertArrayPipe],
})
export class DashboardHeaderComponent {
  currencyAry: any[] = [];
  selectedCurrency: any;
  userData: any;
  selectedLanguage: any = 'English';
  languages: any[] = [
    { lang: 'English', code: 'EN' },
    { lang: 'عربي', code: 'AR' },
  ];
  activeLang: any = 'EN';
  balance: any;
  agencyBalance: string = '0';
  agencyCreditLimit: number = 0;
  agencyNetBalance: number = 0;
  agencyCurrency: string = '';
  isBalanceOnCredit: boolean = false;
  menus: any[] = [];
  menuTree: any[] = [];
  isMobileMenuOpen: boolean = false;
  agencyLogoUrl: any;

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  constructor(
    private currencySettings: CurrencySettingsService,
    private dbService: IndexedDbService,
    public authService: AuthService,
    private api: ApiService,
    private renderer: Renderer2,
    private convertArray: ConvertArrayPipe,
  ) {
    //this.channel = AppConstants_settings.CHANNEL;
    //this.dbService.setData("userCurr",this.selectedCurrency);
    let currData: any;
    this.dbService.getData('userCurr').then((data) => {
      currData = data;
      if (currData) {
        this.currencySettings.setCurrency(
          currData.TargetCurrency,
          currData.SellROE,
        );
        this.selectedCurrency = this.currencySettings.currencySymbol;
      }
    });
    //this.getLoginUserData();
    this.getCurrencyData();
    //this.selectLanguage('EN');
  }

  ngAfterViewInit(): void {
    this.getProfileData();
    this.getLogoData();
    this.selectedCurrency = this.currencySettings.currencySymbol;
    this.dbService.getData('userLang').then((data) => {
      if (data) {
        let selectedLang: any = this.languages.filter((dta: any) => {
          return dta.code == data;
        });
        if (data == 'EN') {
          this.renderer.setAttribute(document.body, 'dir', 'ltr');
          this.selectedLanguage = 'English';
        } else {
          this.renderer.setAttribute(document.body, 'dir', 'rtl');
          this.selectedLanguage = 'عربي';
        }
        // this.selectedLanguage = selectedLang[0]?.lang;
      }
    });
  }

  get sortedLanguages() {
    return this.languages.slice().sort((a, b) => {
      return a.lang === this.selectedLanguage
        ? 1
        : b.lang === this.selectedLanguage
          ? -1
          : 0;
    });
  }

  getLoginUserData() {
    this.dbService.getData('userInfo').then((data) => {
      if (data) {
        try {
          this.userData = typeof data === 'string' ? (data !== 'undefined' && data !== 'null' ? JSON.parse(data) : null) : data;
        } catch (e) {
          console.error('Error parsing userInfo in dashboard-header:', e);
          this.userData = null;
        }
      }
    });
  }

  getLogoData() {
    this.dbService.getData('tokenData').then((data) => {
      if (data) {
        this.agencyLogoUrl = this.api.agencyLogoUrl + data?.AgencyLogo;
      }
    });
  }

  getCurrencyData(): void {
    this.dbService
      .getData('websiteSetting')
      .then((websiteData: any) => {
        // 🧠 Safety check
        if (!websiteData || !websiteData.CompanyId) {
          console.warn('⚠️ No website setting or CompanyId found.');
          this.currencyAry = [];
          return;
        }

        const payload = {
          companyId: websiteData.CompanyId,
        };

        // 🔁 API Call
        this.api.getCurrencyData(payload).subscribe({
          next: (res: any) => {
            if (res && res.statuscode === 1 && res?.jsondata) {
              try {
                this.currencyAry = JSON.parse(res.jsondata);
                this.currencyAry.sort((a: any, b: any) => {
                  const currA = a.TargetCurrency?.toUpperCase() || '';
                  const currB = b.TargetCurrency?.toUpperCase() || '';
                  return currA.localeCompare(currB);
                });
              } catch (e) {
                console.error('❌ Error parsing currency data JSON:', e);
                this.currencyAry = [];
              }
            } else {
              this.currencyAry = [];
              console.warn('⚠️ Currency API returned unexpected format:', res);
            }
          },
          error: (err) => {
            console.error('❌ Error fetching currency data:', err);
            this.currencyAry = [];
          },
        });
      })
      .catch((err) => {
        console.error('❌ Error reading website settings:', err);
        this.currencyAry = [];
      });
  }

  selectCurrency(currency: string): void {
    const conversionRate = this.currencyAry.find(
      (item) => item.TargetCurrency === currency,
    );
    this.dbService.setData('userCurr', conversionRate);
    if (conversionRate) {
      this.currencySettings.setCurrency(currency, conversionRate.SellROE);
    }
    this.selectedCurrency = this.currencySettings.currencySymbol;
  }

  selectLanguage(lang: any): void {
    const langCode = lang.code.toUpperCase();
    this.activeLang = langCode;

    // Sync both storage mechanisms
    this.dbService.setData('userLang', langCode);
    localStorage.setItem('userLang', langCode);

    if (langCode === 'EN') {
      this.selectedLanguage = 'English';
    } else {
      this.selectedLanguage = 'عربي';
    }

    window.location.reload();
  }

  logout() {
    this.authService.logout();
  }

  onHomeClick() {
    this.authService.gotoHome();
  }

  getProfileData() {
    this.dbService.getData('tokenData').then((data) => {
      if (data) {
        this.userData = data;
        this.getBalance();
        this.getMenus();
      }
    });
  }
  async getBalance() {
    let userData = await this.dbService.getData('tokenData');
    if (userData) {
      this.api
        .getAvailableBalance(
          userData?.AgentId || 0,
          userData?.AgencyBranchId || 0,
          AppConstants_settings.COMPANY_ID || 0,
        )
        .subscribe({
          next: (response: any) => {
            if (response?.statuscode === 1) {
              const data = response.data;
              this.agencyCreditLimit = Number(data?.creditLimit) || 0;
              // Same figure as Agency Statements' "Current Balance" (raw Agency_Wallet.Balance,
              // synced from Agency_Ledger) - not netted against ReservedBalance, so this always
              // matches what the ledger page shows.
              this.agencyNetBalance = Number(data?.balance) || 0;
              this.agencyCurrency = data?.agencyCurrency || '';
              // Negative balance means the agency is drawing on its credit limit to fund
              // bookings; positive means real wallet funds are available.
              this.isBalanceOnCredit = this.agencyNetBalance < 0;
              this.agencyBalance =
                this.agencyNetBalance + ' ' + this.agencyCurrency;
            }
          },
          error: (error) => {
            console.error('Error loading balance:', error);
          },
        });
    }
  }

  getMenus() {
    let Agency_Menus: any = {
      companyId: AppConstants_settings.COMPANY_ID,
      agentId: this.userData?.AgentId,
      AgencyUserId: this.userData?.AgencyUserId,
    };

    this.api.getMenus(Agency_Menus).subscribe({
      next: (response: any) => {
        this.menus = response;
        this.buildMenuTree();
      },
      error: (error) => {
        console.error('Error loading menus:', error);
      },
    });
  }

  buildMenuTree() {
    const map = new Map();

    this.menus.forEach((item: any) => {
      item.children = [];
      map.set(item.menuId, item);
    });

    this.menuTree = [];

    this.menus.forEach((item: any) => {
      if (item.parentId === 0) {
        this.menuTree.push(item);
      } else {
        const parent = map.get(item.parentId);
        if (parent) {
          parent.children.push(item);
        }
      }
    });
  }
}
